import React from "react";
import "./PushNotifications.css";

const PushNotifications = () => {
  return (
    <div className="push-notifications">
      <div className="analytics-header">
        <h1>Push Notification Analytics</h1>
      </div>
      <div className="analytics-grid">
        <div className="analytics-card">
          <div className="card-icon total">
            <span className="material-icons">notifications</span>
          </div>
          <div className="card-content">
            <h3>Total Sent</h3>
            <p className="metric-value">45,230</p>
          </div>
        </div>
        <div className="analytics-card">
          <div className="card-icon delivered">
            <span className="material-icons">check_circle</span>
          </div>
          <div className="card-content">
            <h3>Delivered</h3>
            <p className="metric-value">42,845</p>
          </div>
        </div>
        <div className="analytics-card">
          <div className="card-icon opened">
            <span className="material-icons">mark_email_read</span>
          </div>
          <div className="card-content">
            <h3>Opened</h3>
            <p className="metric-value">18,520</p>
          </div>
        </div>
        <div className="analytics-card">
          <div className="card-icon rate">
            <span className="material-icons">percent</span>
          </div>
          <div className="card-content">
            <h3>Open Rate</h3>
            <p className="metric-value">43.2%</p>
          </div>
        </div>
      </div>
      <div className="info-message">
        <span className="material-icons">info</span>
        <p>Push notification analytics dashboard coming soon with engagement metrics and trends</p>
      </div>
    </div>
  );
};

export default PushNotifications;
